import PropTypes from 'prop-types';
import React from 'react';
import { withApplicationContext } from '../../../../../utils/ApplicationContext';
import { withRatings } from '../../../../../utils/RatingsContext';
import { PDPBasicInfoShared } from '../../../../common/PDPBasicInfoShared';
import PDPBasicInfoMobileStyle from './PDPBasicInfoMobile.style';

const PDPBasicInfoMobile = ({ product, ratings, labels, appCtx }) => {
  return (
    <PDPBasicInfoShared
      appCtx={appCtx}
      product={product}
      ratings={ratings}
      labels={labels}
      template="softline"
      customStyle={PDPBasicInfoMobileStyle}
    />
  );
};

PDPBasicInfoMobile.propTypes = {
  product: PropTypes.object.isRequired,
  labels: PropTypes.object.isRequired,
  ratings: PropTypes.object.isRequired,
  appCtx: PropTypes.object.isRequired,
};

export default withRatings(withApplicationContext(PDPBasicInfoMobile));
